import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/image.png'
import _imports_1 from '../../assets/image1.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-250c65ac")

_pushScopeId("data-v-250c65ac")
const _hoisted_1 = { style: {"flex":"1"} }
const _hoisted_2 = { style: {"box-sizing":"border-box","color":"black","padding":"20px 0"} }
const _hoisted_3 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_4 = {
  class: "collapse-content",
  style: {"padding":"20px"},
  key: "content"
}
const _hoisted_5 = { style: {"display":"flex"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 上传数据")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 阈值配置")
const _hoisted_8 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_10 = { class: "dialogForm" }
const _hoisted_11 = { class: "dialogTitle" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "上传性能数据", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "el-icon-upload" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" 将文件拖到此处，或 "),
  /*#__PURE__*/_createVNode("em", null, "点击上传")
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "el-upload__tip" }, " 只能上传zip文件，且不超过2GB ", -1)
const _hoisted_16 = { class: "dialog-footer" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("重 置")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("确 定")
const _hoisted_19 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { style: {"border-bottom":"2px solid #c1c1c1","flex-grow":"1"} }, null, -1)
const _hoisted_21 = { style: {"width":"32px","height":"32px"} }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { style: {"border-bottom":"2px solid #c1c1c1","flex-grow":"1"} }, null, -1)
const _hoisted_23 = { style: {"padding":"30px 30px","background":"#d1edff"} }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { style: {"display":"flex","justify-content":"space-between"} }, [
  /*#__PURE__*/_createVNode("h5", {
    id: "report_scroll",
    class: "TitleStyle"
  }, [
    /*#__PURE__*/_createVNode("span"),
    /*#__PURE__*/_createTextVNode("测试信息 ")
  ])
], -1)
const _hoisted_25 = { style: {"display":"flex"} }
const _hoisted_26 = { class: "no-bullet" }
const _hoisted_27 = /*#__PURE__*/_createVNode("span", null, "测试场景:", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("span", null, "测试时间:", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("span", null, "测试时长:", -1)
const _hoisted_30 = {
  class: "no-bullet",
  style: {"margin":"0 200px"}
}
const _hoisted_31 = /*#__PURE__*/_createVNode("span", null, "机型:", -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("span", null, "芯片:", -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("span", null, "GPU:", -1)
const _hoisted_34 = { class: "no-bullet" }
const _hoisted_35 = /*#__PURE__*/_createVNode("span", null, "当前版本:", -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("span", null, "对比版本:", -1)
const _hoisted_37 = { class: "testMain" }
const _hoisted_38 = { class: "module_djalog" }
const _hoisted_39 = { class: "dialog-content configurationStyle" }
const _hoisted_40 = { class: "form-items" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_42 = { class: "check_style" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode("变差就有风险")
const _hoisted_44 = { class: "check_style" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = {
  key: 2,
  style: {"margin":"0 10px"}
}
const _hoisted_47 = /*#__PURE__*/_createTextVNode("启用基线")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("启用变化阈值")
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = /*#__PURE__*/_createVNode("h5", {
  id: "report_scroll",
  class: "TitleStyle"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("性能概况 ")
], -1)
const _hoisted_57 = { style: {"font-weight":"bold"} }
const _hoisted_58 = /*#__PURE__*/_createVNode("h6", { style: {"display":"flex","align-items":"center","margin":"8px 0 8px 0"} }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode(" 局内趋势 ")
], -1)
const _hoisted_59 = {
  key: 0,
  class: "pos_fps",
  style: {"display":"flex","text-align":"center","color":"#fff","font-size":"10px"}
}
const _hoisted_60 = {
  key: 1,
  style: {"height":"350px"},
  id: "fps_inside"
}
const _hoisted_61 = {
  key: 2,
  class: "pos_fps",
  style: {"display":"flex","text-align":"center","color":"#fff","font-size":"10px"}
}
const _hoisted_62 = {
  key: 3,
  style: {"height":"350px"},
  id: "cpu_inside"
}
const _hoisted_63 = {
  key: 4,
  class: "pos_fps",
  style: {"display":"flex","text-align":"center","color":"#fff","font-size":"10px"}
}
const _hoisted_64 = {
  key: 5,
  style: {"height":"350px"},
  id: "gpu_inside"
}
const _hoisted_65 = {
  key: 6,
  class: "pos_fps",
  style: {"display":"flex","text-align":"center","color":"#fff","font-size":"10px"}
}
const _hoisted_66 = {
  key: 7,
  style: {"height":"350px"},
  id: "thread_inside"
}
const _hoisted_67 = /*#__PURE__*/_createVNode("h6", { style: {"display":"flex","align-items":"center","margin":"20px 0 8px 0"} }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode(" 迭代趋势 ")
], -1)
const _hoisted_68 = {
  key: 0,
  style: {"height":"350px"},
  id: "fps_iteration"
}
const _hoisted_69 = {
  key: 1,
  style: {"height":"350px"},
  id: "cpu"
}
const _hoisted_70 = {
  key: 2,
  style: {"height":"350px"},
  id: "gpu_iteration"
}
const _hoisted_71 = {
  key: 3,
  style: {"height":"350px"},
  id: "threadTrand"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_space = _resolveComponent("el-space")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode(_Transition, { name: "collapse" }, {
                  default: _withId(() => [
                    _withDirectives(_createVNode("div", _hoisted_4, [
                      _createVNode(_component_el_form, {
                        class: "anaysis_class",
                        inline: true,
                        size: "mini"
                      }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_5, [
                            _createVNode(_component_el_form_item, { label: "是否自动" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.auto_query,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.auto_query = $event)),
                                  placeholder: "请选择",
                                  multiple: "",
                                  onChange: _cache[2] || (_cache[2] = ($event: any) => (
                          _ctx.versionChange(false, ['type', 'scene', 'device'])
                        )),
                                  "collapse-tags": "",
                                  "collapse-tags-tooltip": ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.auto_data, (item, k) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: k,
                                        label: item.label,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  size: "mini",
                                  style: {"margin-left":"20px"},
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submitUpload('open')))
                                }, {
                                  default: _withId(() => [
                                    _hoisted_6
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_ctx.report_data.length != 1)
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 0,
                                  label: "父类型"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      filterable: "",
                                      onChange: _cache[4] || (_cache[4] = ($event: any) => (
                          _ctx.versionChange(
                            false,
                            ['type', 'scene', 'device'],
                            (_ctx.subtype_query = '')
                          )
                        )),
                                      modelValue: _ctx.type_query,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.type_query = $event)),
                                      placeholder: "请选择"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_data, (item, k) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: k,
                                            label: item.name,
                                            value: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.report_data.length != 1)
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 1,
                                  label: "子类型"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[6] || (_cache[6] = ($event: any) => (
                          _ctx.versionChange(false, ['type', 'scene', 'device'])
                        )),
                                      key: _ctx.sub_key,
                                      filterable: "",
                                      modelValue: _ctx.subtype_query,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.subtype_query = $event)),
                                      placeholder: "请选择"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sub_data, (item, k) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: k,
                                            label: item.name,
                                            value: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  size: "mini",
                                  style: {"margin-left":"20px"},
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.configurationShow = true))
                                }, {
                                  default: _withId(() => [
                                    _hoisted_7
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form, {
                        inline: true,
                        size: "mini",
                        class: "anaysis_class"
                      }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_8, [
                            _createVNode(_component_el_form_item, {
                              class: "version_input",
                              label: "场景"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.dataConsumeOptions.scene,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.dataConsumeOptions.scene = $event)),
                                  onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.versionChange(false, ['scene', 'device']))),
                                  placeholder: "请选择",
                                  filterable: ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.scene_id,
                                        label: item.scene__chinese,
                                        value: item.scene_id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              class: "version_input",
                              label: "机型"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.dataConsumeOptions.device,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dataConsumeOptions.device = $event)),
                                  onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.versionChange(false, ['device']))),
                                  placeholder: "请选择",
                                  filterable: ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.device_id,
                                        label: 
                            item.device__level +
                            '档机-' +
                            item.device__model__name +
                            '-' +
                            item.device__model__model +
                            '-' +
                            item.device__UUID
                          ,
                                        value: item.device_id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              class: "version_input",
                              label: "版本"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.dataConsumeOptions.version,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.dataConsumeOptions.version = $event)),
                                  placeholder: "请选择",
                                  onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.versionChange(true))),
                                  filterable: ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.versionsOptions, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item.chinese,
                                        value: item.chinese
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              class: "version_input",
                              label: "对比版本"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.dataConsumeOptions.old_verson,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.dataConsumeOptions.old_verson = $event)),
                                  placeholder: "请选择",
                                  filterable: ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.versionsOldOptions, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item.chinese,
                                        value: item.chinese
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  onClick: _ctx.confirm,
                                  type: "primary"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_9
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ], 512), [
                      [_vShow, _ctx.serchDataShow]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode("div", _hoisted_10, [
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.dialogVisible,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.dialogVisible = $event)),
                    width: "30%",
                    onClose: _cache[24] || (_cache[24] = ($event: any) => (_ctx.dialogVisible = false))
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    footer: _withId(() => [
                      _createVNode("span", _hoisted_16, [
                        _createVNode(_component_el_button, {
                          size: "small",
                          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.submitUpload('no')))
                        }, {
                          default: _withId(() => [
                            _hoisted_17
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "primary",
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.submitUpload('ok')))
                        }, {
                          default: _withId(() => [
                            _hoisted_18
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        model: _ctx.dialogForm,
                        size: "small",
                        "label-position": "top"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "地图" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.dialogForm.scene_id,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.dialogForm.scene_id = $event)),
                                placeholder: "请选择地图"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getScenes, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.chinese,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "设备" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.dialogForm.UUID,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.dialogForm.UUID = $event)),
                                placeholder: "请选择设备"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.DeviceSpecs, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: 
                          item.model.name +
                          ' (' +
                          item.model.model +
                          ') - ' +
                          item.UUID
                        ,
                                      value: item.UUID,
                                      title: 
                          item.model.name +
                          ' (' +
                          item.model.model +
                          ') - ' +
                          item.UUID
                        
                                    }, null, 8, ["label", "value", "title"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "场景脚本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.dialogForm.script_id,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.dialogForm.script_id = $event)),
                                placeholder: "请选择场景脚本"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getScripts(_ctx.dialogForm.scene_id), (script) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: script.script_id,
                                      label: script.script_name,
                                      value: script.script_id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"]),
                      _createVNode(_component_el_form, {
                        model: _ctx.dialogForm,
                        size: "small",
                        "label-position": "top"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "上传文件" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_upload, {
                                class: "upload-demo",
                                drag: "",
                                action: "http://127.0.0.1:8081/api/v1/deep_performance/nzm_simple_upload/",
                                multiple: "",
                                limit: 1,
                                "before-upload": _ctx.beforeUpload,
                                ref: 'upload',
                                "http-request": _ctx.UploadFile
                              }, {
                                tip: _withId(() => [
                                  _hoisted_15
                                ]),
                                default: _withId(() => [
                                  _hoisted_13,
                                  _hoisted_14
                                ]),
                                _: 1
                              }, 8, ["before-upload", "http-request"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_space, { size: 150 }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, {
                                label: "任务记录",
                                align: "center"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    style: {"width":"150px"},
                                    modelValue: _ctx.dialogForm.task_record_id,
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.dialogForm.task_record_id = $event)),
                                    placeholder: "请输入任务记录id..."
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "任务组索引" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    style: {"width":"150px"},
                                    modelValue: _ctx.dialogForm.task_group_index,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.dialogForm.task_group_index = $event)),
                                    placeholder: "请输入索引..."
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode("div", _hoisted_21, [
                    (!_ctx.serchDataShow)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          style: {"width":"100%","height":"100%"},
                          onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.openBtn && _ctx.openBtn(...args))),
                          src: _imports_0,
                          alt: ""
                        }))
                      : (_openBlock(), _createBlock("img", {
                          key: 1,
                          style: {"width":"100%","height":"100%"},
                          onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.openBtn && _ctx.openBtn(...args))),
                          src: _imports_1,
                          alt: ""
                        }))
                  ]),
                  _hoisted_22
                ]),
                _withDirectives(_createVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createVNode("div", _hoisted_25, [
                    _createVNode("ul", _hoisted_26, [
                      _createVNode("li", null, [
                        _hoisted_27,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.scene), 1)
                      ]),
                      _createVNode("li", null, [
                        _hoisted_28,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.tiemline), 1)
                      ]),
                      _createVNode("li", null, [
                        _hoisted_29,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.duration), 1)
                      ])
                    ]),
                    _createVNode("ul", _hoisted_30, [
                      _createVNode("li", null, [
                        _hoisted_31,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.device_level +
                      "-" +
                      _ctx.report_data_list?.device_name), 1)
                      ]),
                      _createVNode("li", null, [
                        _hoisted_32,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.cpu_name), 1)
                      ]),
                      _createVNode("li", null, [
                        _hoisted_33,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.gpu_name), 1)
                      ])
                    ]),
                    _createVNode("ul", _hoisted_34, [
                      _createVNode("li", null, [
                        _hoisted_35,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.version), 1)
                      ]),
                      _createVNode("li", null, [
                        _hoisted_36,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.old_version), 1)
                      ])
                    ])
                  ])
                ], 512), [
                  [_directive_loading, _ctx.report_text_show]
                ]),
                _createVNode("div", _hoisted_37, [
                  _createVNode("div", _hoisted_38, [
                    _createVNode(_component_el_dialog, {
                      modelValue: _ctx.configurationShow,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_ctx.configurationShow = $event)),
                      width: "70%",
                      class: "custom-dialog",
                      height: "auto"
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_39, [
                          _createVNode(_component_el_form, {
                            inline: true,
                            size: "mini"
                          }, {
                            default: _withId(() => [
                              _createVNode("div", _hoisted_40, [
                                _createVNode(_component_el_form_item, { label: "选择场景" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _ctx.configChange,
                                      modelValue: _ctx.configuration_form.scene_id,
                                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.configuration_form.scene_id = $event)),
                                      placeholder: "请选择",
                                      filterable: ""
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options_old_table, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.scene_id,
                                            label: item.scene__chinese,
                                            value: item.scene_id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["onChange", "modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "选择平台" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _ctx.configChange,
                                      modelValue: _ctx.configuration_form.moudle,
                                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.configuration_form.moudle = $event)),
                                      placeholder: "选择平台",
                                      filterable: ""
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.moudle, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: item,
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["onChange", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createVNode(_component_el_form_item, { class: "save-button" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _ctx.save_button
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_41
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode("div", _hoisted_42, [
                            _createVNode(_component_el_checkbox, {
                              onChange: _cache[29] || (_cache[29] = ($event: any) => (
                          _ctx.is_bad_risk == true
                            ? (_ctx.threshold_check = false)
                            : (_ctx.threshold_check = _ctx.threshold_check)
                        )),
                              modelValue: _ctx.is_bad_risk,
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.is_bad_risk = $event))
                            }, {
                              default: _withId(() => [
                                _hoisted_43
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _createVNode("div", _hoisted_44, [
                            (!_ctx.baseline_check)
                              ? (_openBlock(), _createBlock("span", _hoisted_45, "添加基线列"))
                              : (_openBlock(), _createBlock("span", {
                                  key: 1,
                                  style: {"color":"#409eff","cursor":"pointer"},
                                  onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.addRow_baseline()))
                                }, "添加基线列")),
                            (!_ctx.threshold_check)
                              ? (_openBlock(), _createBlock("span", _hoisted_46, "添加变化阈值列"))
                              : (_openBlock(), _createBlock("span", {
                                  key: 3,
                                  style: {"margin":"0 10px","color":"#409eff","cursor":"pointer"},
                                  onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.addRow_threshold()))
                                }, "添加变化阈值列")),
                            _createVNode(_component_el_checkbox, {
                              modelValue: _ctx.baseline_check,
                              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.baseline_check = $event))
                            }, {
                              default: _withId(() => [
                                _hoisted_47
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_el_checkbox, {
                              disabled: _ctx.is_bad_risk,
                              modelValue: _ctx.threshold_check,
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.threshold_check = $event))
                            }, {
                              default: _withId(() => [
                                _hoisted_48
                              ]),
                              _: 1
                            }, 8, ["disabled", "modelValue"])
                          ]),
                          _createVNode(_component_el_table, {
                            border: "",
                            size: "mini",
                            "header-cell-style": {
                        background: '#5D99D5',
                        color: '#fff',
                      },
                            "cell-style": _ctx.cellStyle2,
                            data: _ctx.configuration_table_data
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, {
                                width: "120",
                                label: "指标"
                              }, {
                                default: _withId((scope) => [
                                  (
                              scope.$index == 5 &&
                              (_ctx.baseline_check || _ctx.threshold_check)
                            )
                                    ? (_openBlock(), _createBlock(_component_el_input, {
                                        key: 0,
                                        modelValue: scope.row.name,
                                        "onUpdate:modelValue": ($event: any) => (scope.row.name = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                    : (_openBlock(), _createBlock("span", _hoisted_49, _toDisplayString(scope.row.name), 1))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, { label: "基线" }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.configuration_table_baseline, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_table_column, {
                                      width: "150",
                                      key: index
                                    }, {
                                      header: _withId(() => [
                                        (!_ctx.baseline_check)
                                          ? (_openBlock(), _createBlock("div", _hoisted_50, [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.value, (i) => {
                                                return (_openBlock(), _createBlock("span", {
                                                  style: 
                                  'margin-right:10px;display: inline-block;padding:0px 5px;background:' +
                                  _ctx.gear_position.filter((c) => c.value == i)[0]
                                    ?.background
                                ,
                                                  key: i
                                                }, _toDisplayString(_ctx.gear_position.filter((c) => c.value == i)[0]
                                    ?.name), 5))
                                              }), 128))
                                            ]))
                                          : (_openBlock(), _createBlock(_component_el_select, {
                                              key: 1,
                                              modelValue: item.value,
                                              "onUpdate:modelValue": ($event: any) => (item.value = $event),
                                              placeholder: "请选择",
                                              multiple: "",
                                              size: "mini",
                                              "collapse-tags": "",
                                              "collapse-tags-tooltip": ""
                                            }, {
                                              default: _withId(() => [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.determine(
                                  _ctx.configuration_table_baseline,
                                  _ctx.gear_position_all,
                                  index
                                ), (item, k) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: k,
                                                    label: item.name,
                                                    value: item.value,
                                                    disabled: item.disabled
                                                  }, null, 8, ["label", "value", "disabled"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                      ]),
                                      default: _withId((scope) => [
                                        (!_ctx.baseline_check && scope.row.name != '')
                                          ? (_openBlock(), _createBlock("span", _hoisted_51, _toDisplayString(scope.row.baseline[index]), 1))
                                          : (
                                !_ctx.baseline_check && scope.row.name === ''
                              )
                                            ? (_openBlock(), _createBlock("span", _hoisted_52, _toDisplayString(scope.row.baseline[index]), 1))
                                            : (_ctx.baseline_check && scope.row.name != '')
                                              ? (_openBlock(), _createBlock(_component_el_input, {
                                                  key: 2,
                                                  modelValue: scope.row.baseline[index],
                                                  "onUpdate:modelValue": ($event: any) => (scope.row.baseline[index] = $event)
                                                }, {
                                                  default: _withId(() => [
                                                    _createTextVNode(_toDisplayString(scope.row.baseline[index]), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                              : (_ctx.baseline_check && scope.row.name == '')
                                                ? (_openBlock(), _createBlock("span", {
                                                    key: 3,
                                                    style: {"color":"#409eff","cursor":"pointer"},
                                                    onClick: ($event: any) => (_ctx.delete_baseline(index))
                                                  }, _toDisplayString(scope.row.baseline[index]), 9, ["onClick"]))
                                                : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, { label: "变化阈值" }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.configuration_table_threshold, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_table_column, {
                                      width: "150",
                                      key: index
                                    }, {
                                      header: _withId(() => [
                                        (!_ctx.threshold_check)
                                          ? (_openBlock(), _createBlock("div", _hoisted_53, [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.value, (i) => {
                                                return (_openBlock(), _createBlock("span", {
                                                  style: 
                                  'margin-right:10px;display: inline-block;padding:0px 5px;background:' +
                                  _ctx.gear_position.filter((c) => c.value == i)[0]
                                    .background
                                ,
                                                  key: i
                                                }, _toDisplayString(_ctx.gear_position.filter((c) => c.value == i)[0]
                                    .name), 5))
                                              }), 128))
                                            ]))
                                          : (_openBlock(), _createBlock(_component_el_select, {
                                              key: 1,
                                              modelValue: item.value,
                                              "onUpdate:modelValue": ($event: any) => (item.value = $event),
                                              placeholder: "请选择",
                                              multiple: "",
                                              size: "mini",
                                              "collapse-tags": "",
                                              "collapse-tags-tooltip": ""
                                            }, {
                                              default: _withId(() => [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.determine(
                                  _ctx.configuration_table_threshold,
                                  _ctx.gear_position_all_threshold,
                                  index
                                ), (item, k) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: k,
                                                    label: item.name,
                                                    value: item.value,
                                                    disabled: item.disabled
                                                  }, null, 8, ["label", "value", "disabled"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                      ]),
                                      default: _withId((scope) => [
                                        (!_ctx.threshold_check && scope.row.name != '')
                                          ? (_openBlock(), _createBlock("span", _hoisted_54, _toDisplayString(scope.row.threshold[index]), 1))
                                          : (
                                !_ctx.threshold_check && scope.row.name == ''
                              )
                                            ? (_openBlock(), _createBlock("span", _hoisted_55, _toDisplayString(scope.row.threshold[index]), 1))
                                            : (
                                _ctx.threshold_check && scope.row.name != ''
                              )
                                              ? (_openBlock(), _createBlock(_component_el_input, {
                                                  key: 2,
                                                  modelValue: scope.row.threshold[index],
                                                  "onUpdate:modelValue": ($event: any) => (scope.row.threshold[index] = $event)
                                                }, {
                                                  default: _withId(() => [
                                                    _createTextVNode(_toDisplayString(scope.row.threshold[index]), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                              : (
                                _ctx.threshold_check && scope.row.name == ''
                              )
                                                ? (_openBlock(), _createBlock("span", {
                                                    key: 3,
                                                    onClick: ($event: any) => (_ctx.delete_threshold(index)),
                                                    style: {"color":"#409eff","cursor":"pointer"}
                                                  }, _toDisplayString(scope.row.threshold[index]), 9, ["onClick"]))
                                                : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["cell-style", "data"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createVNode("div", null, [
                    _hoisted_56,
                    _createVNode(_component_el_form, {
                      inline: true,
                      size: "mini"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "选择场景" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              onChange: _ctx.sceneChangeTrend,
                              modelValue: _ctx.scene_risk,
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.scene_risk = $event)),
                              placeholder: "请选择"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sub_scene, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item,
                                    value: item
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["onChange", "modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_openBlock(), _createBlock("div", {
                      key: _ctx.cou,
                      style: {"display":"flex","justify-content":"space-around","margin":"20px 0 40px 0"}
                    }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.risk_list_data, (item, k, index) => {
                        return _withDirectives((_openBlock(), _createBlock("div", {
                          style: {
                      width: '170px',
                      height: '80px',
                      background: _ctx.itemBgColorName[k],
                      display: 'flex',
                      borderRadius: '15px',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                    },
                          key: index,
                          onClick: ($event: any) => (_ctx.boxChange(k))
                        }, [
                          _createVNode("div", _hoisted_57, _toDisplayString(item.replace(/线程耗时/, "")), 1),
                          _createVNode("div", null, [
                            _createVNode("span", {
                              style: 
                          'color:' +
                          _ctx.risk_data(item, k)[3] +
                          ';font-size:16px;font-weight:bold'
                        
                            }, _toDisplayString(_ctx.risk_data(item, k)[0]), 5),
                            _createVNode("span", null, _toDisplayString(_ctx.risk_data(item, k)[6]), 1)
                          ]),
                          _createVNode("div", null, [
                            _createVNode("span", {
                              style: 
                          'color:' +
                          _ctx.risk_data(item, k)[4] +
                          ';font-size:16px;font-weight:bold'
                        
                            }, _toDisplayString(_ctx.risk_data(item, k)[2] + _ctx.risk_data(item, k)[5]), 5),
                            _createVNode("span", null, _toDisplayString(_ctx.risk_data(item, k)[6]), 1)
                          ])
                        ], 12, ["onClick"])), [
                          [_vShow, _ctx.risk_data(item, k)[0] != '0']
                        ])
                      }), 128))
                    ])),
                    _createVNode("div", null, [
                      _hoisted_58,
                      _createVNode(_component_el_card, { style: {"position":"relative","width":"100%"} }, {
                        default: _withId(() => [
                          (_ctx.trendShow.avg_fps || _ctx.trendShow.max_pss)
                            ? (_openBlock(), _createBlock("div", _hoisted_59, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fps_list, (item, index) => {
                                  return (_openBlock(), _createBlock("div", {
                                    key: index,
                                    style: {
                          background: item.color,
                          width: item.width,
                        }
                                  }, _toDisplayString(_ctx.getName(item.label, index)), 5))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.trendShow.avg_fps || _ctx.trendShow.max_pss)
                            ? (_openBlock(), _createBlock("div", _hoisted_60))
                            : _createCommentVNode("", true),
                          (_ctx.trendShow.avg_cpu)
                            ? (_openBlock(), _createBlock("div", _hoisted_61, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cpu_list, (item, index) => {
                                  return (_openBlock(), _createBlock("div", {
                                    key: index,
                                    style: {
                          background: item.color,
                          width: item.width,
                        }
                                  }, _toDisplayString(_ctx.getName(item.label, index)), 5))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.trendShow.avg_cpu)
                            ? (_openBlock(), _createBlock("div", _hoisted_62))
                            : _createCommentVNode("", true),
                          (_ctx.trendShow.read_total || _ctx.trendShow.write_total)
                            ? (_openBlock(), _createBlock("div", _hoisted_63, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gpu_list, (item, index) => {
                                  return (_openBlock(), _createBlock("div", {
                                    key: index,
                                    style: {
                          background: item.color,
                          width: item.width,
                        }
                                  }, _toDisplayString(_ctx.getName(item.label, index)), 5))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.trendShow.read_total || _ctx.trendShow.write_total)
                            ? (_openBlock(), _createBlock("div", _hoisted_64))
                            : _createCommentVNode("", true),
                          (_ctx.risk_list_data[_ctx.tag_name]?.indexOf('线程') != -1)
                            ? (_openBlock(), _createBlock("div", _hoisted_65, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.thread_list, (item, index) => {
                                  return (_openBlock(), _createBlock("div", {
                                    key: index,
                                    style: {
                          background: item.color,
                          width: item.width,
                        }
                                  }, _toDisplayString(_ctx.getName(item.label, index)), 5))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.risk_list_data[_ctx.tag_name]?.indexOf('线程') != -1)
                            ? (_openBlock(), _createBlock("div", _hoisted_66))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("div", null, [
                      _hoisted_67,
                      _createVNode(_component_el_card, null, {
                        default: _withId(() => [
                          (_ctx.trendShow.avg_fps || _ctx.trendShow.max_pss)
                            ? (_openBlock(), _createBlock("div", _hoisted_68))
                            : _createCommentVNode("", true),
                          (_ctx.trendShow.avg_cpu)
                            ? (_openBlock(), _createBlock("div", _hoisted_69))
                            : _createCommentVNode("", true),
                          (_ctx.trendShow.read_total || _ctx.trendShow.write_total)
                            ? (_openBlock(), _createBlock("div", _hoisted_70))
                            : _createCommentVNode("", true),
                          (_ctx.risk_list_data[_ctx.tag_name]?.indexOf('线程') != -1)
                            ? (_openBlock(), _createBlock("div", _hoisted_71))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})